<ng-container *ngIf="menuOptions && menuOptions.length > 0">
  <div *ngFor="let option of menuOptions; trackBy:identify" class="option-item-container">
    <a [class.active]="htmlId === option.htmlId" class="option-item" href="/ayuda/faq?categoria={{ option.htmlId }}">
      {{option.title}}
    </a>
  </div>
</ng-container>